import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { ibanGateway, IbanGatewayManipulationViewModel } from "./ibanGatewayManipulation-viewModel"

export class IbanGatewayManipulationView extends View<IbanGatewayManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-9B095DF6-7C13-4DE1-8355-705C7DC2D78C"
    }
    loadHtml(): string {
        let element = require('./ibanGatewayManipulation.html').default;
        let style = require('./ibanGatewayManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    public set ibanGateway(v: ObservableArray<ibanGateway>) { this._ibanGateway = v; } public get ibanGateway(): ObservableArray<ibanGateway> { return this._ibanGateway;} private _ibanGateway: ObservableArray<ibanGateway>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestIbanGatewayCreation(){
        this.dataContext.requestIbanGatewayCreation();
    }
}
